import { baseClient } from '@/shared/api/baseClient';

import type {
  ResetPasswordConfirmRequest,
  ResetPasswordConfirmResponse,
} from '../model/types';

export const resetPasswordConfirmAsync = async (
  data: ResetPasswordConfirmRequest
) => {
  const response = await baseClient.post<ResetPasswordConfirmResponse>(
    `/auth/reset-password/${data.resetPasswordKey}`,
    { password: data.password, confirm_password: data.confirm_password }
  );

  return response.data;
};
